"use client";

import { c as _c } from "react/compiler-runtime";
import { FiClock, FiX } from "react-icons/fi";
import { formatDateTime } from "@/lib/format-data";
import { useCancelScheduledMessageMutation, useScheduledMessages } from "@/query/comms/chat";
export function ScheduledMessagesList(t0) {
  const $ = _c(7);
  const {
    chatId
  } = t0;
  const {
    data: scheduledMessages
  } = useScheduledMessages(chatId);
  const cancelMutation = useCancelScheduledMessageMutation(chatId);
  if (!scheduledMessages || scheduledMessages.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== cancelMutation || $[1] !== scheduledMessages) {
    let t2;
    if ($[3] !== cancelMutation) {
      t2 = scheduledMessage => <div key={scheduledMessage.id} className="flex items-center gap-2 rounded-lg border border-border bg-muted px-3 py-1.5 text-caption"><FiClock className="size-3.5 shrink-0 text-foreground-secondary" /><span className="shrink-0 text-foreground-secondary">Scheduled for {formatDateTime(scheduledMessage.sendAt)}</span><span className="truncate text-foreground">{scheduledMessage.content}</span><button type="button" onClick={() => cancelMutation.mutate(scheduledMessage.id)} disabled={cancelMutation.isPending} aria-label="Cancel scheduled message" className="ml-auto shrink-0 text-foreground-muted hover:text-foreground"><FiX className="size-4" /></button></div>;
      $[3] = cancelMutation;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = scheduledMessages.map(t2);
    $[0] = cancelMutation;
    $[1] = scheduledMessages;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <div className="mb-2 flex flex-col gap-1">{t1}</div>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}